import React from "react";
import {
  Document,
  Font,
  Page,
  Text,
  Image,
  StyleSheet,
  View,
} from "@react-pdf/renderer";
import logo from "../../../../assets/img/logo-removebg-preview.png";

// Registrar fuentes
Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

Font.register({
  family: "Times-Bold",
  src: "https://fonts.gstatic.com/s/timesnewroman/v1/NiX7eS-8kFObHLkSXE4QGo6lWzYJpivMTA.ttf",
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 20,
    paddingBottom: 40,
    paddingHorizontal: 40,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#000000",
  },
  headerRow: {
    flexDirection: "row",
    alignItems: "center",
    padding: 5,
    backgroundColor: "#f2f2f2",
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#000000",
  },
  title: {
    fontSize: 22,
    fontFamily: "Oswald",
    width: "75%",
    textAlign: "center",
  },
  image: {
    width: 50,
    height: 50,
    textAlign: "center",
  },
  detailsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#000000",
    borderTopWidth: 0,
    marginBottom: 10,
  },
  detailsCol: {
    width: "25%",
    fontSize: 10,
    fontFamily: "Times-Bold",
    textAlign: "center",
    padding: 10,
  },
  table: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#000000",
    marginTop: 15,
  },
  tableRow: {
    flexDirection: "row",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#000000",
  },
  tableColHeader: {
    width: "50%", // Dos columnas
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#000000",
    padding: 5,
    backgroundColor: "#f2f2f2",
    textAlign: "center",
  },
  tableCol: {
    width: "50%", // Dos columnas
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#000000",
    padding: 5,
    textAlign: "center",
  },
  tableCellHeader: {
    fontSize: 10,
    fontFamily: "Times-Bold",
  },
  tableCell: {
    fontSize: 10,
    fontFamily: "Times-Roman",
  },
  footer: {
    position: "absolute",
    fontSize: 10,
    bottom: 20,
    left: 40,
    right: 40,
    textAlign: "center",
    color: "grey",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
});

const formatDateTime = (date) => {
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  };
  return new Intl.DateTimeFormat("es-ES", options).format(date);
};

function MyDocument({ data }) {
  const currentDate = new Date();
  const formattedDate = formatDateTime(currentDate);

  return (
    <>
      {data ? (
        <Document title={`Reporte de Inventario - ${formattedDate}`}>
          <Page style={styles.body} wrap>
            <View style={styles.headerRow}>
              <Text style={styles.title}>Reporte de Inventario</Text>
              <Image style={styles.image} src={logo} />
            </View>

            <View style={styles.detailsRow}>
              <Text style={styles.detailsCol}>Código: </Text>
              <Text style={styles.detailsCol}>Versión: </Text>
              <Text style={styles.detailsCol}>Fecha:</Text>
              <Text style={styles.detailsCol}>Página: 1 de 1</Text>
            </View>
            
            <View style={styles.table}>

              {/* Fila 1 */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Nombre</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{data.producto.nombre}</Text>
                </View>
              </View>

              {/* Fila 2 */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Referencia</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{data.producto.referencia}</Text>
                </View>
              </View>

              {/* Fila 3 */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Descripción</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{data.producto.descripcion}</Text>
                </View>
              </View>

              {/* Fila 4 */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Entradas</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{data.entradas}</Text>
                </View>
              </View>

              {/* Fila 5 */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Salidas</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{data.salidas || 0}</Text>
                </View>
              </View>

              {/* Fila 6 */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Gastos de Producción</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{data.gastos_produccion}</Text>
                </View>
              </View>

              {/* Fila 7 */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Inventario Actual</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{data.inventario}</Text>
                </View>
              </View>

              {/* Fila 8 */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Costo Unitario</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    $ {data.costo_unitario || "N/A"}
                  </Text>
                </View>
              </View>

              {/* Fila 9 */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Costo Total</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    $ {data.costo_total || "N/A"}
                  </Text>
                </View>
              </View>
            </View>
          </Page>
        </Document>
      ) : (
        <Text>No se pudieron obtener los datos del producto</Text>
      )}
    </>
  );
}

export default MyDocument;
